import DOMPurify from 'dompurify';
import {ALERT_VARIANT, EpersonalStatus} from '../const/dataEnum';
import {setAlert} from '../stores/actions/alertModalStateAction';

export const removeWhitespace = (text) => {
  if (text) {
    return text.replace(/\s+/g, '').toLowerCase();
  }

  return null;
};

export function extractTextValues(periodList) {
  if (!Array.isArray(periodList)) {
    console.error('periodList must be an array');
    return [];
  }

  const textValues = periodList.map((period) => {
    if (typeof period !== 'object' || period === null || !('text' in period)) {
      console.error('Each item in periodList must be an object with a "text" property');
      return '';
    }
    return period.text.toString();
  });

  return textValues;
}

export const statusTranslator = (status) => {
  switch (status) {
    case EpersonalStatus.COMPLETE:
      return 'Complete';
    case EpersonalStatus.INCOMPLETE:
      return 'Incomplete';
    case EpersonalStatus.NOT_STARTED:
      return 'not started';
    // case 3:
    //   return 'Done';
    default:
      return 'Unknown';
  }
};

export const generateMarkupFromDraftjs = (stringHtml) => {
  const domPurifyConfig = {
    ALLOWED_TAGS: ['a', 'p', 'span', 'div', 'b', 'i', 'u', 'strong', 'em', 'table', 'tr', 'td'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'id'],
  };
  return {
    __html: DOMPurify.sanitize(stringHtml, domPurifyConfig),
  };
};

export const showAlert = (response, successMessage, errorMessage) => (dispatch) => {
  let message = errorMessage ?? 'Something went wrong';
  let alertVariant = ALERT_VARIANT.ERROR;

  if (response) {
    if (response?.responseCode) {
      if (response?.responseCode === 0) {
        message = successMessage;
        alertVariant = ALERT_VARIANT.SUCCESS;
      } else {
        message = errorMessage ?? response?.message;
      }
    } else {
      message = successMessage;
      alertVariant = ALERT_VARIANT.SUCCESS;
    }
  }

  if (message) {
    dispatch(
      setAlert({
        show: true,
        variant: alertVariant,
        message: message,
        timeout: 4000,
      })
    );
  }
};

export const enhanceReducer = (reducer) => {
  return (state, action) => {
    if (process.env.NODE_ENV === 'development') {
      console.groupCollapsed(`ReducerLogger - Action: ${action.type}`);
      console.log('%cPrevious State:', 'color: #9E9E9E; font-weight: bold;', state);
      console.log('%cAction:', 'color: #00A7F7; font-weight: bold;', action);
      const newState = reducer(state, action);
      console.log('%cNext State:', 'color: #47B04B; font-weight: bold;', newState);
      console.groupEnd();
      return newState;
    }
    return reducer(state, action);
  };
};

export const parseDate = (str) => {
  if (!str || typeof str !== 'string') return new Date(0);
  const [day, month, year] = str.split('/');
  const date = new Date(`${year}-${month}-${day}`);
  return isNaN(date) ? new Date(0) : date;
};

export const getDefaultValue = (type) => {
  switch (type) {
    case 'department':
      return {id: 0, departmentName: '', longName: ''};
    case 'practice':
      return {id: 0, departmentID: 0, practiceName: ''};
    case 'role':
      return {id: 0, roleName: ''};
    case 'roleLevel':
      return {id: 0, roleLevelName: '', roleID: -1, roleLevelDescription: ''};
    default:
      throw new Error(`Unknown default type: ${type}`);
  }
};
